module.exports = __webpack_public_path__ + "media/images/recipes/varkensfiletrolade-80b2085048fa263b03e762e94163192d.pdf";